// Splits CMS article HTML into the markup that sits before and after the
// newsletter banner. The banner is rendered (build-time compiled) between the
// two chunks by the consuming page, so the split point is just before the
// second `<h2>` (i.e. the end of the first h2 section). When there is at most
// one `<h2>` the banner falls at the end of the article, so `after` is empty.
export const modifyWithNewsletterPlaceholderDiv = (body) => {
	const splitSeparator = "<h2";
	const splitByH2 = body.split(splitSeparator);

	if (splitByH2.length <= 1) {
		return { before: body, after: "" };
	}

	return {
		before: `${splitByH2[0]}${splitSeparator}${splitByH2[1]}`,
		after:
			splitByH2.length > 2
				? `${splitSeparator}${splitByH2.slice(2).join(splitSeparator)}`
				: "",
	};
};
